<template>
  <v-card
    :outlined="cardOutlined"
    :class="cardElevation"
    :flat="flat"
    class="mx-auto"
    :min-height="cardDimension.height"
    :max-height="cardDimension.height"
    :min-width="cardDimension.width"
    :max-width="cardDimension.width"
  >
    <v-row no-gutters>
      <v-col md="showPercentage ? 8 : 12">
        <p :class="cardDimension.valueClass"><span :class="lookupColor(label)">{{ value }}</span></p>
      </v-col>
      <v-col md="4" v-if="showPercentage">
        <p :class="cardDimension.percentClass">{{ percentage | percent(1) }}</p>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col md="showIcon ? 8 : 12">
        <p :class="cardDimension.labelClass" class="text-uppercase text-left">{{ decoratedLabel(label) }}</p>
      </v-col>
      <v-col md="4" v-if="showIcon">
        <v-icon :color="lookupColor(label)" :class="cardDimension.iconClass" :size="cardDimension.iconSize">{{ lookupIcon(label) }}</v-icon>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mergeDeepRight } from 'ramda'
import { MAIL_EVENT_DECORATORS } from '@/constants'

export default {
  name: 'stat-card',
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: [Number, String],
      required: true
    },
    percentage: {
      type: Number,
      required: false,
    },
    color: {
      type: String,
      required: false,
      default: 'primary'
    },
    useCampaignDecorators: {
      type: Boolean,
      required: false,
      default: false
    },
    icon: {
      type: String,
      required: false
    },
    small: {
      type: Boolean,
      required: false
    },
    noIcon: {
      type: Boolean,
      required: false
    },
    cardDimensionsOverride: {
      type: Object,
      require: false,
      default: function () {
        return {}
      }
    },
    flat: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      cardDimensions: mergeDeepRight({
        default: {
          width: 180,
          height: 98,
          valueClass: 'display-1 ml-4 mt-2',
          percentClass: 'subtitle-2 mt-2 mr-2 text-right',
          labelClass: 'body-2 font-weight-light ml-4 mb-2',
          iconClass: 'mb-2 mr-2 pl-6',
          iconSize: 'x-large'
        },
        small: {
          width: 130,
          height: 70,
          valueClass: 'headline ml-2',
          percentClass: 'caption mt-2 mr-1 text-right',
          labelClass: 'caption font-weight-light ml-2',
          iconClass: 'mb-2 pl-4',
          iconSize: 'medium'
        }
      }, this.cardDimensionsOverride), // merge any overrides in that are needed
      campaignDecorators: MAIL_EVENT_DECORATORS,
      cardOutlined: true,
      cardElevation: 'elevation-2'
    }
  },
  computed: {
    cardDimension () {
      if (this.small) {
        return this.cardDimensions.small
      } else {
        return this.cardDimensions.default
      }
    },
    showIcon () {
      if (this.noIcon) return false

      return !!this.icon || !!this.useCampaignDecorators
    },
    showPercentage () {
      return !!this.percentage
    }
  },
  methods: {
    campaignDecorator (label) {
      return this.campaignDecorators[label] || {}
    },
    lookupIcon (label) {
      if (this.useCampaignDecorators) {
        return this.campaignDecorator(label).icon
      } else {
        return this.icon
      }
    },
    lookupColor (label) {
      if (this.useCampaignDecorators) {
        return this.campaignDecorator(label).color || this.color
      } else {
        return this.color
      }
    },
    decoratedLabel (label) {
      if (this.useCampaignDecorators) {
        if (label.startsWith('unsubscribe')) {
          if (label.endsWith('global')) {
            return 'Unsub Global'
          } else {
            return 'Unsub Camp...'
          }
        } else {
          return label.replace('_', ' ')
        }
      } else {
        return label.replace('_', ' ')
      }
    }
  },
  watch: {
    flat: {
      immediate: true,
      handler (newVal, oldVal) {
        if (newVal) {
          this.cardOutlined = false
          this.cardElevation = ''
        } else {
          this.cardOutlined = true
          this.cardElevation = 'elevation-2'
        }
      }
    }
  }
}
</script>
